/**
 * The Symagic Server Demand entity.
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
/**
 * The Symagic Server Demand entity.
 */
var Demand = /** @class */ (function () {
    function Demand() {
        /**
         * Holding Reference of task
         * @private
         * @type {Entity}
         */
        this.task = undefined;
    }
    Object.defineProperty(Demand.prototype, "Task", {
        /**
         * Gets the task of the demand.
         * @readonly
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (!this.task && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.task;
        },
        /**
         * Sets the task of the demand
         */
        set: function (value) {
            if (value && value !== this.task && this.entityAspect.entityState.isAdded()) {
                this.Start = value['Start'];
                this.Finish = value['Finish'];
                this.Name = value['Name'];
                this.Color = value['Color'];
                this['SumFactor'] = value['SumFactor'];
                // Deze kan weg wanneer #2150 afgerond is.
                // this.Notes = value['Notes'];
            }
            this.task = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Demand.prototype, "EffortFreeSlot", {
        /**
         * Gets the best guess for marketplace free slot Deployment.Effort.
         * @readonly
         * @type {string}
         */
        get: function () {
            var deployments = this['Deployments'];
            if (deployments) {
                var found = deployments.find(function (item) { return item['Resource_Oid'] == null || item['Resource_Oid'] === ''; });
                if (found) {
                    return found['Effort'];
                }
            }
            // Deployments not loaded?
            return this['WorkUnit'];
        },
        /**
         * Setter of the EffortFreeSlot. Only for to support angular two-way binding.
         */
        set: function (value) {
            // Only for angular 2 way binding.
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes Taskneed instance from this object with taking into account situations of inherited collections.
     * @param {string} taskNeed The Oid of the Taskneed to remove.
     * @param {boolean} [afterSave=false] Indicates whether the method is invoked after properties changes are committed or before
     * @memberOf Demand
     */
    Demand.prototype.removeNeed = function (taskNeed, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'RemoveNeed', [taskNeed], afterSave);
    };
    return Demand;
}());
export { Demand };
